import {
    getAsLongDate, getAsLongDateTime, getAsShortDate, getAsShortDateTime, getAsTimeFormat, correctBrowserTimezone } from '../../TempZaddonsJSLib/ukgDateTime';
import { UkgDateFormat } from '../../Enums';
import i18n from '../../../i18n';

class DateFormatService {
    /**
     * @param { Date | string | null } date
     * @param { number } format
     */

    formatDateOrEmpty = (date, format) => {
        if (!date || date === 'Invalid date') {
            return '';
        }

        // TODO: FIX THAT !
        if(date === 'Forever' || date === '3000-01-01' || date === 'Pour toujours'){
            return i18n.t('workplanManager:workPlanView.global.forever');
        }

        const hasExplicitTimezone = /\b\d{1,2}:\d{2}(:\d{2})?/.test(date);
        
        if(typeof date === 'string'){
            if(!hasExplicitTimezone){
                date = correctBrowserTimezone(new Date(date))
            }else{
                date = new Date(date)
            }
        }
        
        switch (format) {
            case UkgDateFormat.ShortDate:
                return getAsShortDate(date);
            case UkgDateFormat.ShortDateTime:
                return getAsShortDateTime(date);
            case UkgDateFormat.LongDate:
                return getAsLongDate(date);
            case UkgDateFormat.LongDateTime:
                return getAsLongDateTime(date);
            case UkgDateFormat.TimeFormat:
                return getAsTimeFormat(date);
            default:
                return getAsLongDateTime(date);
        }
    };

    /**
     * @param { Date | string | null } fromDate
     * @param { Date | string | null } toDate
     * @param { number } format
     */
    formatPeriod = (fromDate, toDate, format) => `${this.formatDateOrEmpty(fromDate, format)} - ${this.formatDateOrEmpty(toDate, format)}`;
}

export default (new DateFormatService());
